import { Footer } from "../../components/Footer/Footer"
import { Header } from "../../components/Header/Header"
import AdditionalBanner from "./AdditionalBanner/AdditionalBanner"
import AdditionalList from "./AdditionalList/AdditionalList"


const AdditionalPage = () => {


    return (
        <>
            <Header />
            <AdditionalBanner />
            <AdditionalList />
            <Footer /> 
        </>
    )
}

export default AdditionalPage